import { PartialNullable } from "../../Extensions";
import { ArrayHelper } from "../../Helpers/ArrayHelper";
import { Property } from "../../RadObject";
import { CheckBoxList, CheckBoxListPropertyValues, ICheckBoxList } from "./CheckBoxList";
import { NAMESPACE } from "./_Namespace";

export type CheckBoxListPermissionPropertyValues =
    CheckBoxListPropertyValues
    & {
    };

export type CheckBoxListPermissionProperties = {
    [name in keyof CheckBoxListPermissionPropertyValues]: Property<CheckBoxListPermissionPropertyValues[name]>
};

export interface ICheckBoxListPermission extends ICheckBoxList, CheckBoxListPermissionProperties
{
}

export class CheckBoxListPermission extends CheckBoxList implements ICheckBoxListPermission
{
    // #region Static

    public static override classNamespace = NAMESPACE + "CheckBoxListPermission";
    public static override className = "CheckBoxListPermission";

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<CheckBoxListPermissionPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Protected Methods

    protected _powersOfTwoFromArray(powers: number[])
    {
        let
            value = 0;

        powers.forEach(item => { value += item; });

        return value;
    }
    protected _powersOfTwoToArray(value: number)
    {
        const
            powers = [];

        let
            power = 0;

        while (value !== 0)
        {
            if ((value & 1) !== 0)
                powers.push(1 << power);
            ++power;
            value >>>= 1;
        }

        return powers;
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: CheckBoxListPermissionPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.text.overrideGet(next =>
        {
            let
                value = next();

            if (!value)
                value = "None";

            return value;
        });
        this.value.overrideGet(next =>
        {
            let
                value = next();

            if (!ArrayHelper.isArrayLike(value))
                value = [];

            value = this._powersOfTwoFromArray(value as number[]);

            return value === null ? 0 : value;
        });
        this.value.overrideSet((value, next) =>
        {
            if (value === null)
                value = 0;
            else if (typeof value === "number")
                value = this._powersOfTwoToArray(value);

            next(value);
        });
    }

    protected override _refreshFromDataSource()
    {
        const
            dataSource = this.dataSource.get(),
            dataSourceProperty = this.dataSourceProperty.get();

        if (dataSource && dataSourceProperty && dataSource.propertyValueByPathGet(dataSourceProperty) === null)
            dataSource.propertyValueByPathSet(dataSourceProperty, 0);

        super._refreshFromDataSource();
    }

    // #endregion

    // #endregion
}

